import {
  ContactTeaserData,
  SerializedContactTeaserData,
} from '@/search/useSearchContact/Interfaces';
import { SerializedContactTeaser } from '@/search/useSearchContact/serializer/ContactTeaserSerializer';

/**
 * Serializes a contact teaser response object
 * @param rawData A contact teaser response object
 * @returns A serialized contact teaser response object
 * @example
 * const contactTeaser = new ContactTeaser(rawData);
 * console.log(contactTeaser.data);
 */
export class ContactTeaser {
  public data: SerializedContactTeaserData;

  constructor(rawData: ContactTeaserData) {
    this.data = SerializedContactTeaser(rawData);
  }
}
